import { withAngularComponent } from '../../base/decorators';
import BaseComponent from '../../base/component';
import template from './template.html';
import './style.scss';

export const COUNTER_ALL = 'ALL';

export const COUNTER_NON_RATED = 'NON_RATED';

export const COUNTER_GOOD_FIT = 'GOOD_FIT';

export const COUNTER_NOT_FIT = 'NOT_FIT';

@withAngularComponent({
    name: 'tftFeedbackFilter',
    template,
    bindings: {
        filterState: '<',
        onFilterStateChange: '&',
        isRecruiterMode: '@',
    },
    controllerAs: 'tftFeedbackFilterCtrl',
})
export default class TFTFeedbackFilter extends BaseComponent {
    onCounterClick(selectedState) {
        if (selectedState !== this.filterState.selected) {
            this.onFilterStateChange({
                filterState: {
                    ...this.filterState,
                    selected: selectedState,
                },
            });
        }
    }
}
